import {
	init as initSentry,
	type BrowserOptions,
	getCurrentScope,
	browserTracingIntegration,
} from "@sentry/react";

type MonitoringOptions = Pick<BrowserOptions, "beforeSend"> & {
	readonly sentryDsn: string | undefined;
	readonly sentryEnvironment: string | undefined;
	readonly number: string;
	readonly commitId: string;
	readonly buildTimestamp: string;
};

function initMonitoring({
	number,
	commitId,
	buildTimestamp,
	sentryDsn,
	sentryEnvironment,
	beforeSend,
}: MonitoringOptions) {
	if (sentryDsn) {
		initSentry({
			dsn: sentryDsn,
			environment: sentryEnvironment,
			release: commitId,
			integrations: [browserTracingIntegration()],
			normalizeDepth: 6,
			beforeSend,
		});
	}

	const buildTime = new Date(parseInt(buildTimestamp, 10) * 1_000);
	// eslint-disable-next-line no-console
	console.log("App version", number, commitId, buildTime.toISOString());
	// eslint-disable-next-line no-console
	console.log("Sentry initialised", !!sentryDsn);

	getCurrentScope().setExtras({
		launchTime: new Date().toISOString(),
		versionNumber: number,
		versionId: commitId,
		buildTime: buildTime.toISOString(),
	});
}

export default initMonitoring;
